<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";

// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      modelData: {
        id: "",
        name: "",
        image: "",
        status: "1",
      },
      //qr_code_image_delete_url: process.env.VUE_APP_APIURL + "delete-qr-code-image",
      profile_image: "",
      profile_image_path: "",
      profile_image_delete_url: process.env.VUE_APP_APIURL + "delete-banner-image",
      qr_code: {
        image: "",
      },
      searchData: debounce(() => {
        this.getBanners();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "name",
          sortable: true,
          label: "Name",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: { DropzonePopup },
  validations: {
    modelData: {
      name: { required },
      image: {},
      status: { required },
    },
  },
  computed: {
    ...mapGetters("banner", [
      "getAllBanner",
      "loading",
      "bannerCount",
      "pagination",
      "getShowBanner",
      "getUpdateStatus",
    ]),
  },
  mounted() {
    this.getBanners();
  },
  watch: {},
  methods: {
    ...mapActions("banner", [
      "getBanner",
      "showBanner",
      "addOrUpdateBanner",
      "deleteBanner",
    ]),
    onUserImagedeleted() {
      this.profile_image = "";
    },
    getBanners(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getBanner(filters);
    },
    addBannerModel() {
      this.modelData.id = "";
      this.modelData.name = "";
      this.modelData.image = "";
      this.modelData.status = "1";
      this.$bvModal.show("bv-modal-add-banner");
    },
    editBanner(banner_id) {
      this.resetForm();
      var data = {
        id: banner_id,
      };
      this.showBanner(data).then(() => {
        this.modelData.id = this.getShowBanner.id;
        this.modelData.name = this.getShowBanner.name;
        this.profile_image_path = this.getShowBanner.web_image_path;
        this.profile_image = this.getShowBanner.image;
        this.modelData.status = this.getShowBanner.status;
        this.$bvModal.show("bv-modal-edit-banner");
      });
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.modelData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.modelData.id);
        fd.append("name", this.modelData.name);
        fd.append("status", this.modelData.status);
        if (this.modelData.image) {
          fd.append("image", this.modelData.image);
        }
        this.addOrUpdateBanner(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getBanners();
          }
          this.modelData.image = "";
          this.$bvModal.hide("bv-modal-edit-banner");
        });
      }
    },
    submitAddForm() {
      this.$v.$touch();
      if (this.$v.modelData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.modelData.name);
        fd.append("status", this.modelData.status);
        if (this.modelData.image) {
          fd.append("image", this.modelData.image);
        }
        this.addOrUpdateBanner(fd).then((response) => {
          console.log(response);
          if (this.getUpdateStatus == 200) {
            this.getBanners();
          }
          this.modelData.image = "";
          this.$bvModal.hide("bv-modal-add-banner");
        });
      }
    },
    deleteBanners(banner_id) {
      if (confirm("Are You Sure to Delete #" + banner_id + " Banner")) {
        const fd = new FormData();
        fd.append("id", banner_id);
        this.deleteBanner(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getBanners();
          }
        });
      }
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getBanners();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-4">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">Banners ({{ bannerCount }})</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addBannerModel();
                      $bvModal.show('bv-modal-add-banner');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Banner
                  </b-button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllBanner"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editBanner(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deleteBanners(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllBanner.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Banner Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getBanners"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Add vehicle make Model start -->
    <b-modal id="bv-modal-add-banner" size="lg" hide-footer @hidden="resetForm">
      <template #modal-title>Add Banner</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Name"
                v-model="$v.modelData.name.$model"
                :class="{ 'is-invalid': $v.modelData.name.$error }"
                name="name"
              />
              <div v-if="$v.modelData.name.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.name.required">Please enter name</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Status</label>
              <select
                v-model="$v.modelData.status.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.status.$error }"
              >
                <option value="0">In-Active</option>
                <option value="1" selected>Active</option>
              </select>
              <div v-if="$v.modelData.status.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.status.required">Please select status</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 card">
            <div class="form-group mb-3">
              <h4 class="card-title required">Banner Image</h4>
              <p class="card-title-desc"></p>

              <div class="row mt-n3">
                <div class="col-sm-12">
                  <dropzone-popup
                    type="file"
                    v-model="modelData.image"
                    id="profile_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :delete-path="profile_image_delete_url"
                    :class="{ 'is-invalid': $v.modelData.image.$error }"
                    @image-deleted="this.onUserImagedeleted"
                  />
                  <div
                    v-if="$v.modelData.image.$error"
                    class="invalid-feedback cuisine-img"
                  >
                    <span v-if="!$v.modelData.image.required">Image is required.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-banner');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Add vehicle make Model end -->
    <!-- Edit vehicle make Model start -->
    <b-modal id="bv-modal-edit-banner" size="lg" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Banner</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Name"
                v-model="$v.modelData.name.$model"
                :class="{ 'is-invalid': $v.modelData.name.$error }"
                name="name"
              />
              <div v-if="$v.modelData.name.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.name.required">Please enter name</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Status</label>
              <select
                v-model="$v.modelData.status.$model"
                class="form-control"
                :class="{ 'is-invalid': $v.modelData.status.$error }"
              >
                <option disabled value="">Please select one</option>
                <option value="0">In-Active</option>
                <option value="1">Active</option>
              </select>
              <div v-if="$v.modelData.status.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.status.required">Please select status</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 card">
            <div class="form-group mb-3">
              <h4 class="card-title required">Banner Image</h4>
              <p class="card-title-desc"></p>
              <div class="row mt-n3">
                <div class="col-sm-12">
                  <dropzone-popup
                    type="file"
                    v-model="modelData.image"
                    id="profile_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :editable-images="profile_image"
                    :media-path="profile_image_path + 'original'"
                    :delete-path="profile_image_delete_url"
                    @image-deleted="this.onUserImagedeleted"
                  />
                  <div
                    v-if="$v.modelData.image.$error"
                    class="invalid-feedback cuisine-img"
                  >
                    <span v-if="!$v.modelData.image.required">Image is required.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-banner');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Edit vehicle make Model end -->
  </div>
</template>
<style>
.multiselect {
  width: 100% !important;
}
.btn-success {
  background-color: #ff3350 !important;
  border-color: #ff3350 !important;
}
.table-class {
  table-layout: fixed;
}
.table-class th:first-child {
  width: 50px;
}
.table-class th:nth-child(2n) {
  width: 150px;
}
.table-class th:nth-child(5n) {
  width: 150px;
}
.table-class th:nth-child(6n) {
  width: 100px;
}
.table-class th:nth-child(4n) {
  width: 200px;
}
</style>
